import { useMemo, useCallback, useState } from 'react';

import { IItemKey } from 'api/catalog/models';
import { LocalStorageService } from 'api/localStorage/services';
import { LocalStorageKey } from 'api/localStorage/constants';

import { useItemAttributes } from './useItemAttributes';

export const useVisibilityOptions = (
  key: LocalStorageKey,
  defaultFields: IItemKey[] = []
) => {
  const { isItemAttribute } = useItemAttributes();
  const safeFields = useMemo(() => {
    const localStorageSaved = LocalStorageService.getValue<IItemKey[]>(key);
    if (localStorageSaved) {
      return localStorageSaved.filter(isItemAttribute);
    } else {
      return defaultFields;
    }
  }, [defaultFields, isItemAttribute, key]);

  const [visibleFields, setVisibleFields] = useState<IItemKey[]>(safeFields);

  const handleVisibleFieldsChange = useCallback(
    (visibleFields: IItemKey[] = defaultFields) => {
      const safeVisibleFields = visibleFields.filter(isItemAttribute);
      LocalStorageService.setValue<IItemKey[]>(key, safeVisibleFields);
      setVisibleFields(safeVisibleFields);
    },
    [defaultFields, isItemAttribute, key]
  );

  return { visibleFields, handleVisibleFieldsChange };
};
